<template>
    <Dialog v-model:visible="show" modal :header="message.header" :style="{ width: '25rem' }" :closable="true" 
        :dismissable-mask="true" @hide="hideDialog" class="text-center">
        <i :class="message.icon + ' text-4xl mb-4 text-green-500 dark:text-green-400'"></i>
        <span class="text-surface-500 dark:text-surface-400 block mb-8">
            {{ message.message }}
        </span>
    </Dialog>
</template>

<script setup>

import Dialog from 'primevue/dialog';
import { useRoute } from 'vue-router';
import { ref } from 'vue';

const route = useRoute();
const show = ref(false);
const message = ref({
    header: '',
    message: '',
    icon: ''
});

const showDialog = (options) => {
    message.value = {
        header: options.header || '',
        message: options.message || '',
        icon: options.icon || '',
    };
    show.value = true;
};

const hideDialog = () => {
    show.value = false;

    // Remove query parameters from URL after dialog is closed
    const url = new URL(window.location);
    url.searchParams.delete('verified');
    window.history.replaceState({}, document.title, url.toString());
};

if (route.query.verified === 'true') {
    showDialog({
        header: 'Success',
        message: 'Your email has been successfully verified.',
        icon: 'pi pi-check-circle',
    });
} else if (route.query.verified === 'false') {
    showDialog({
        header: 'Error',
        message: 'Email verification failed. Please try again.',
        icon: 'pi pi-times-circle',
    });
}

</script>